module.exports = __webpack_public_path__ + "img/img-5b00ad.jpg";